export default function SymbolRender(props) {
  return (
    <span className={`text-[0.6rem] ${props.value?.includes('PERP') ? 'bg-yellow-300/20' : ''}`}>
      {props.value}
    </span>
  );
}
